var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNameplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "160 160 3020 905",
    preserveAspectRatio: "xMinYMid meet",
    fill: "currentColor",
    stroke: "none",
    fillRule: "evenodd",
    role: "img",
    "aria-label": "Pulse Robotics",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 200 920          A 80 80 0 0 0 280 1000          L 920 1000          A 80 80 0 0 0 1000 920          L 1000 560          A 40 40 0 0 0 960 520          L 720 520          A 40 40 0 0 0 680 560          L 680 800          A 40 40 0 0 1 640 840          L 280 840          A 80 80 0 0 0 200 920          z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1000 280          A 80 80 0 0 1 920 360          L 560 360          A 40 40 0 0 0 520 400          L 520 640          A 40 40 0 0 1 480 680          L 240 680          A 40 40 0 0 1 200 640          L 200 280          A 80 80 0 0 1 280 200          L 920 200          A 80 80 0 0 1 1000 280          z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wordmark",
    fontFamily: "Roboto, system-ui, -apple-system, Segoe UI, Arial, sans-serif",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("text", {
    x: 1150,
    y: 720,
    fontSize: 600,
    fontWeight: 800,
    dominantBaseline: "alphabetic",
    letterSpacing: 40
  }, "PULSE"), /*#__PURE__*/React.createElement("text", {
    x: 1400,
    y: 980,
    fontSize: 200,
    fontWeight: 500,
    dominantBaseline: "alphabetic",
    letterSpacing: 80
  }, "\n        ROBOTICS\n      ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNameplate);
export default __webpack_public_path__ + "static/media/logo_nameplate.fc7cf8ff94ac4d4f63f57e2b65aab1c1.svg";
export { ForwardRef as ReactComponent };